import { render } from "./Holds.vue?vue&type=template&id=484b69cf"
import script from "./Holds.vue?vue&type=script&lang=js"
export * from "./Holds.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__